import { MenuItem, Select } from '@mui/material';
import { DateRangePicker } from 'rsuite';
import React from 'react';

import Flexbox from 'layouts/flexbox/Flexbox';
import { Gridfield, MultiDropdown } from 'components/Form';

const selectStyles = {
  width: '150px',
  '& .MuiSelect-select': {
    padding: '8px 16px',
    fontSize: '13px',
  },
};

const gridStyles = { display: 'flex', flexDirection: 'column', gap: '10px' };

const UserPageFilters = ({
  statusFilter,
  onStatusChange,
  statuses,
  dateRangeValue,
  onDateRangeChange,
  typeOptions,
  onRequestTypeDropdown,
  requestTypeFilter,
  onRequestTypeChange,
}) => {
  return (
    <Flexbox gap="0 10px">
      <Gridfield label="Type" sx={gridStyles}>
        <MultiDropdown
          placeholder="Select type"
          placeholderSearch="Search"
          value={requestTypeFilter}
          onChange={onRequestTypeChange}
          options={typeOptions}
          onDropdownOpen={onRequestTypeDropdown}
        />
      </Gridfield>

      <Gridfield label="Status" sx={gridStyles}>
        <Select
          value={statusFilter}
          onChange={onStatusChange}
          sx={selectStyles}
        >
          <MenuItem value={statuses.success}>{statuses.success}</MenuItem>
          <MenuItem value={statuses.error}>{statuses.error}</MenuItem>
        </Select>
      </Gridfield>

      <Gridfield label="Date & Time Range" sx={gridStyles}>
        <DateRangePicker
          value={dateRangeValue}
          onChange={onDateRangeChange}
          placeholder="Select Date & Time Range"
          format="yyyy-MM-dd hh:mm aa"
          showMeridian
          style={{ width: '320px' }}
        />
      </Gridfield>
    </Flexbox>
  );
};

export default UserPageFilters;
